import React from "react";
import { ReactComponent as EditIcon } from "../../assets/icons/management/edit.svg";
import { ReactComponent as InfoIcon } from "../../assets/icons/management/info.svg";
import { IProductType } from "../../types/productType.type";
import styles from "./styles.module.scss";

interface Props {
  types: IProductType[];
  callBackInfo: (bool: boolean) => void;
  callBackEdit: (user: IProductType) => void;
}

const ProductTypesTable: React.FC<Props> = (props) => {
  return (
    <table className={styles.customTable}>
      <thead>
        <tr>
          <th>Назва</th>
          <th>Опис</th>

          <th></th>
        </tr>
      </thead>
      <tbody>
        {props.types &&
          props.types.map((user, index) => (
            <tr key={user.id}>
              <td>
                <div className={styles.userInfo}>
                  <div className={styles.nameContainer}>
                    <span className={styles.name}>{user.name}</span>
                  </div>
                </div>
              </td>

              <td className={styles.role}>
                {user.description.length < 300
                  ? user.description
                  : user.description.slice(0, 20)}
                ...
              </td>
              <td>
                <div className={styles.actions}>
                  <button
                    className={styles.editBtn}
                    onClick={() => {
                      props.callBackInfo(false);
                      props.callBackEdit(user);
                    }}
                  >
                    <EditIcon />
                  </button>
                  <button
                    className={styles.infoBtn}
                    onClick={() => {
                      props.callBackInfo(true);
                      props.callBackEdit(user);
                    }}
                  >
                    <InfoIcon />
                  </button>
                </div>
              </td>
            </tr>
          ))}
      </tbody>
    </table>
  );
};

export default ProductTypesTable;
